export default {
  en: {
    validation: {
      invalid: '{label} is not valid',
      max: 'Text must not exceed {max} characters',
      min: 'Text must be at least {min} characters long',
    }
  },
  de: {
    validation: {
      invalid: '{label} ist ungültig',
      max: 'Text darf nicht länger als {max} Zeichen sein',
      min: 'Text muss mindestens {min} Zeichen lang sein',
    }
  },
  es: {
    validation: {
      invalid: '{label} no es válido',
      max: 'El texto no debe exceder de {max} caracteres',
      min: 'El texto debe tener al menos {min} caracteres',
    }
  },
  uk: {
    validation: {
      invalid: '{label} недійсний',
      max: 'Текст не повинен перевищувати {max} символів',
      min: 'Текст повинен бути не менше {min} символів',
    }
  }
}
